"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.11
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var ContactApi = /** @class */ (function (_super) {
    __extends(ContactApi, _super);
    function ContactApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds MOU Signatory for E-Verify
     * Add MOU Signatory for E-Verify
     */
    ContactApi.prototype.addMouSignatoryRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.addUser === null || requestParameters.addUser === undefined) {
                            throw new runtime.RequiredError('addUser', 'Required parameter requestParameters.addUser was null or undefined when calling addMouSignatory.');
                        }
                        if (requestParameters.createMouSignatoryRequest === null || requestParameters.createMouSignatoryRequest === undefined) {
                            throw new runtime.RequiredError('createMouSignatoryRequest', 'Required parameter requestParameters.createMouSignatoryRequest was null or undefined when calling addMouSignatory.');
                        }
                        queryParameters = {};
                        if (requestParameters.addUser !== undefined) {
                            queryParameters['addUser'] = requestParameters.addUser;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts/mou",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateMouSignatoryRequestToJSON(requestParameters.createMouSignatoryRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.MouSignatoryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Adds MOU Signatory for E-Verify
     * Add MOU Signatory for E-Verify
     */
    ContactApi.prototype.addMouSignatory = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addMouSignatoryRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new contact on the provided account. Do not send personId
     * Creates a Contact
     */
    ContactApi.prototype.createContactRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.contact === null || requestParameters.contact === undefined) {
                            throw new runtime.RequiredError('contact', 'Required parameter requestParameters.contact was null or undefined when calling createContact.');
                        }
                        queryParameters = {};
                        if (requestParameters.app !== undefined) {
                            queryParameters['app'] = requestParameters.app;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ContactToJSON(requestParameters.contact),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ContactFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new contact on the provided account. Do not send personId
     * Creates a Contact
     */
    ContactApi.prototype.createContact = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createContactRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deletes a contact. If there is a User with the same personId that user is NOT deleted. Deleting the corresponding User requires a separate call.
     * Delete a contact
     */
    ContactApi.prototype.deleteContactRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.personId === null || requestParameters.personId === undefined) {
                            throw new runtime.RequiredError('personId', 'Required parameter requestParameters.personId was null or undefined when calling deleteContact.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts/{personId}".replace("{" + "personId" + "}", encodeURIComponent(String(requestParameters.personId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes a contact. If there is a User with the same personId that user is NOT deleted. Deleting the corresponding User requires a separate call.
     * Delete a contact
     */
    ContactApi.prototype.deleteContact = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteContactRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get a contact by personID
     */
    ContactApi.prototype.getContactRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.personId === null || requestParameters.personId === undefined) {
                            throw new runtime.RequiredError('personId', 'Required parameter requestParameters.personId was null or undefined when calling getContact.');
                        }
                        queryParameters = {};
                        if (requestParameters.app !== undefined) {
                            queryParameters['app'] = requestParameters.app;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts/{personId}".replace("{" + "personId" + "}", encodeURIComponent(String(requestParameters.personId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ContactFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a contact by personID
     */
    ContactApi.prototype.getContact = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getContactRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of contacts for an account
     */
    ContactApi.prototype.getContactsForAccountRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
                            throw new runtime.RequiredError('accountId', 'Required parameter requestParameters.accountId was null or undefined when calling getContactsForAccount.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts/account/{accountId}".replace("{" + "accountId" + "}", encodeURIComponent(String(requestParameters.accountId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AccountContactsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a list of contacts for an account
     */
    ContactApi.prototype.getContactsForAccount = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getContactsForAccountRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets MOU Signatory for E-Verify
     * Get MOU Signatory for E-Verify
     */
    ContactApi.prototype.getMouSignatoryRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
                            throw new runtime.RequiredError('accountId', 'Required parameter requestParameters.accountId was null or undefined when calling getMouSignatory.');
                        }
                        queryParameters = {};
                        if (requestParameters.accountId !== undefined) {
                            queryParameters['accountId'] = requestParameters.accountId;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts/mou",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.MouSignatoryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets MOU Signatory for E-Verify
     * Get MOU Signatory for E-Verify
     */
    ContactApi.prototype.getMouSignatory = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMouSignatoryRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * An endpoint to update the profile data of a contact. If there is a User with the same personId its profile data is shared and as a result both will be updated.
     * Update a contact by personID
     */
    ContactApi.prototype.updateContactRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.personId === null || requestParameters.personId === undefined) {
                            throw new runtime.RequiredError('personId', 'Required parameter requestParameters.personId was null or undefined when calling updateContact.');
                        }
                        if (requestParameters.person === null || requestParameters.person === undefined) {
                            throw new runtime.RequiredError('person', 'Required parameter requestParameters.person was null or undefined when calling updateContact.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts/{personId}".replace("{" + "personId" + "}", encodeURIComponent(String(requestParameters.personId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PersonToJSON(requestParameters.person),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ContactFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * An endpoint to update the profile data of a contact. If there is a User with the same personId its profile data is shared and as a result both will be updated.
     * Update a contact by personID
     */
    ContactApi.prototype.updateContact = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateContactRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates an MOU Signatory for E-Verify
     * Update MOU Signatory for E-Verify
     */
    ContactApi.prototype.updateMouSignatoryRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.accountId === null || requestParameters.accountId === undefined) {
                            throw new runtime.RequiredError('accountId', 'Required parameter requestParameters.accountId was null or undefined when calling updateMouSignatory.');
                        }
                        if (requestParameters.putMouSignatoryRequest === null || requestParameters.putMouSignatoryRequest === undefined) {
                            throw new runtime.RequiredError('putMouSignatoryRequest', 'Required parameter requestParameters.putMouSignatoryRequest was null or undefined when calling updateMouSignatory.');
                        }
                        queryParameters = {};
                        if (requestParameters.accountId !== undefined) {
                            queryParameters['accountId'] = requestParameters.accountId;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/contacts/mou",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PutMouSignatoryRequestToJSON(requestParameters.putMouSignatoryRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.MouSignatoryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates an MOU Signatory for E-Verify
     * Update MOU Signatory for E-Verify
     */
    ContactApi.prototype.updateMouSignatory = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateMouSignatoryRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ContactApi;
}(runtime.BaseAPI));
exports.ContactApi = ContactApi;
